module.exports = __webpack_public_path__ + "media/images/icon__plus-9b1ac7b064c0d581f07cbec087daa8da.png";